import { Hero } from "@/components/Hero";
import { QuickLinks } from "@/components/QuickLinks";
import { AmenitiesBento } from "@/components/AmenitiesBento";
import { VendorMarquee } from "@/components/VendorMarquee";
import { EventsStrip } from "@/components/EventsStrip";
import { SectionHeading } from "@/components/SectionHeading";
import { Link } from "react-router-dom";
import { SOCIETY } from "@/lib/data";

const Home = () => (
  <div data-testid="home-page">
    <Hero />

    {/* About preview */}
    <section className="py-24 md:py-32 px-6 md:px-10 bg-brand-ivory">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-16 items-center">
        <div className="md:col-span-6">
          <SectionHeading
            overline="The Community"
            title={
              <>
                Four acres of green,
                <br />
                <span className="italic text-brand-gold">438 families, one address.</span>
              </>
            }
            lead="iTowers Exente is a thoughtfully crafted Kolte-Patil community in Konappana Agrahara — a 10-minute walk to Infosys, GE, TCS and the rest of Electronic City's most vibrant tech campuses."
            testId="home-about-heading"
          />
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/about"
              data-testid="home-about-cta"
              className="inline-flex items-center px-6 py-3 rounded-full bg-brand-forest text-brand-ivory text-sm font-medium hover:bg-brand-leaf transition-colors"
            >
              About iTowers Exente
            </Link>
            <a
              href={SOCIETY.mapsUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center px-6 py-3 rounded-full border border-brand-forest/30 text-brand-forest text-sm font-medium hover:bg-brand-sage transition-colors"
            >
              View on Maps
            </a>
          </div>
        </div>
        <div className="md:col-span-6 grid grid-cols-2 gap-4">
          <img
            src="https://images.pexels.com/photos/14198519/pexels-photo-14198519.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Exente exterior"
            className="rounded-2xl object-cover h-56 md:h-80 w-full"
          />
          <img
            src="https://images.unsplash.com/photo-1597329739495-8dac13c8cc3b?auto=format&fit=crop&w=900&q=80"
            alt="Gardens"
            className="rounded-2xl object-cover h-56 md:h-80 w-full mt-10"
          />
          <img
            src="https://images.pexels.com/photos/29149086/pexels-photo-29149086.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Pool"
            className="rounded-2xl object-cover h-56 md:h-80 w-full -mt-8"
          />
          <img
            src="https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=900&q=80"
            alt="Clubhouse"
            className="rounded-2xl object-cover h-56 md:h-80 w-full"
          />
        </div>
      </div>
    </section>

    <AmenitiesBento />
    <VendorMarquee />
    <EventsStrip />
    <QuickLinks />
  </div>
);

export default Home;
